export default __webpack_public_path__ + "static/media/vip-icon.b1f00e4f.svg";